import { KibGrid, KibGridItem } from '@chewy/kib-layout-react'

import { MessageStatus } from '~/constants/communications'
import type { ChatMessage } from '~/types'

import MedicalLabel from './MedicalLabel'

import styles from './MessageHeader.module.scss'

const MessageHeader = ({
  message,
  isReadOnly,
}: {
  isReadOnly: boolean
  message: ChatMessage
}) => {
  const { isMedical, status } = message
  const isDraft = status === MessageStatus.DRAFT

  return (
    <KibGrid className={styles.messageHeader}>
      <KibGridItem>
        <MedicalLabel
          isDraft={isDraft}
          isMedical={isMedical}
          isReadOnly={isReadOnly}
        />
      </KibGridItem>
    </KibGrid>
  )
}

export default MessageHeader
